
export const getEventPropertiesForResourceLogging = (resource) => {
  const eventProperties = {};

  if (!resource) {
    return eventProperties;
  }

  if (!resource.link('self')) {
    return eventProperties;
  }

  const actionItemType = resource.link('self').param('actionItemType');

  if (actionItemType) {
    eventProperties.actionItemType = actionItemType;
  }

  return eventProperties;
};
